import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ActivityInternalComment, ActivityInternalCreateModalComponent, Customer } from 'gung-standard';
import { GungUser as User } from 'gung-standard';

@Component({
    selector: 'cult-cult-activity-internal-create-modal',
    templateUrl: './cult-activity-internal-create-modal.component.html',
    styleUrls: ['./cult-activity-internal-create-modal.component.scss'],
    standalone: false
})
export class CultActivityInternalCreateModalComponent extends ActivityInternalCreateModalComponent {
  initForm(user: User, customer: Customer, responsible: string) {
    super.initForm(user, customer, responsible);
    this.submitForm.controls['customerResponsible'].setValue(this.activity?.customerResponsible || responsible || '');
    this.submitForm.addControl('extra', this.formBuilder.group({
      meetingType: this.formBuilder.control(this.activity?.extra?.meetingType || ''),
      orderValue: this.formBuilder.control(this.activity?.extra?.orderValue || ''),
      spokenInStore: this.formBuilder.control(this.activity?.extra?.spokenInStore || false)
    }));
  }

  updateDate(date: Date, formControl?: string) {
    if (!date || !formControl) {
      return;
    }

    const time: Date = new Date(this.submitForm.get(formControl).value);
    date.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
    this.submitForm.get(formControl).setValue(date);
  }

  updateTime(time: string, formControl: string) {
    if (!time || !formControl) {
      return;
    }

    const date: Date = new Date(this.submitForm.get(formControl).value);
    const timeStringArray: string[] = time.split(':');
    date.setHours(Number(timeStringArray[0]), Number(timeStringArray[1]), 0);
    this.submitForm.get(formControl).setValue(date);
  }

  getCurrentHoursString(formControl: string): string {
    if (!formControl) {
      return;
    }

    const time: Date = new Date(this.submitForm.get(formControl).value);
    return this.padDigits(time.getHours().toString()) + ':' + this.padDigits(time.getMinutes().toString());
  }

  padDigits(number) {
    return Array(Math.max(2 - String(number).length + 1, 0)).join('0') + number;
  }
}
